import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalStyled } from '../../../theme/customizedStyleComponents';
import DynamicFormRenderer from '../renderer/DynamicFormRenderer';

export default class FormPreview extends Component {
    handleClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    handleSubmit = (data) => {
        console.log('Preview form submitted:', data);
        this.handleClose();
    };

    render() {
        const { show, formDefinition } = this.props;

        return (
            <ModalStyled
                size={formDefinition ? formDefinition.modalSize || 'lg' : 'lg'}
                aria-labelledby="form-preview-modal"
                centered
                show={show}
                onHide={this.handleClose}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Form Preview: {formDefinition ? formDefinition.name : ''}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formDefinition && (
                        <DynamicFormRenderer
                            formDefinition={formDefinition}
                            initialData={null}
                            onSubmit={this.handleSubmit}
                            onClose={this.handleClose}
                        />
                    )}
                </Modal.Body>
            </ModalStyled>
        );
    }
}
